import Component from '../core/Component';
import $ from 'jquery';
import { throttle } from 'lodash';
import * as ViewportServices from '../services/Viewport';
import keycodes from 'keycodes';
import { queries } from '../core/config';
import enquire from 'enquire.js';


export default class MenuCategories extends Component {

    constructor($element) {
        super($element);
        this.$body = $('body');
        this.$document = $(document);
        this.$window = $(window);
        this.$nav = $('.nav');

        this.class = 'show-categories';
        this.scrollClass = 'small-menu';
        this.scrollAmount = 200;
    }

    prepare() {
        var self = this

        this.$element.on('click', ::this.toggleCategories);
        this.$document
            .on('click', ::this.closeCategories)
            .on('keyup', ::this.checkEsc);
        enquire.register(queries.mediumUp, {
            match: () => {
                this.$window.on('scroll', throttle(::this.onScroll, 50));
            }
        });
        this.$document.on('load:beforeLeave', () => {
            this.$body.removeClass(this.scrollClass).removeClass(this.class);
        });
        this.$nav.find('.nav__search')
            .on('click', function (event) {
                event.stopPropagation();
            })
        this.$nav.find('a').on('click', function (event) {
            self.$nav.find('a').removeClass('active')
            $(this).addClass('active')
        })
        $('.header__logo').on('click', function (event) {
            self.$nav.find('a').removeClass('active')
        })
    }

    STATE = false;
    SCROLLED = false;

    destroy() {
        this.$document.off('click', ::this.closeCategories);
        this.$window.off('scroll', throttle(::this.onScroll, 50));
    }

    toggleCategories(event) {
        event.stopPropagation();
        if (this.STATE) {
            this.$body.removeClass(this.class);
            this.STATE = false;
        } else {
            this.$body.addClass(this.class);
            this.STATE = true;
        }
    }

    closeCategories(event) {
        let target = (event) ? $(event.target).parents(".nav").length : false;

        if (this.STATE && !target) {
            this.$body.removeClass(this.class);
            this.STATE = false;
        }
    }

    onScroll(event) {
        this.closeCategories();
        if (this.$window.scrollTop() <= this.scrollAmount) {
            var current = false;
        } else {
            var current = true;
        }

        if (current != this.SCROLLED) {
            this.SCROLLED = current;
            if (this.SCROLLED) {
                this.$body.addClass(this.scrollClass);
            } else {
                this.$body.removeClass(this.scrollClass);
            }
        }
    }

    checkEsc(event) {
        if (event.keyCode == keycodes('esc')) {
            this.closeCategories();
        }
    }
}


// WEBPACK FOOTER //
// ./components/Menu.js